import React from "react";
import logo from "../../../assets/icons/logoNew.png";

function Logo({isSidebar}) {
  return (
    <div className="flex flex-col items-center" data-aos="fade-up">
      <img src={logo} alt="logo" className="h-14 duration-300 mb-2 drop-shadow-lg" />
      <h1 className="text-xl font-bold font-myanmarKhay bg-gradient-to-r from-white to-white bg-clip-text text-transparent leading-tight drop-shadow-sm">
        EP SPORTS
      </h1>
      <div className="flex items-center space-x-2 mt-1.5">
        <div className="h-px w-6 bg-gradient-to-r from-transparent via-white to-transparent"></div>
        <p className="text-xs text-white font-bold uppercase tracking-widest">Premium Elite</p>
        <div className="h-px w-6 bg-gradient-to-r from-transparent via-white to-transparent"></div>
      </div>
    </div>
  );
}

export default Logo;
